import * as adminFeed from "../adminFeed"
import * as skylineApi from '../skylineApi'
const groundInactiveIcon = '/images/grs-inactive.png';
const groundRegisteredIcon = '/images/grs-registered.png';

let globalFeedLayer

const markers = {}

export function hide() {
  globalFeedLayer.removeFrom(mymap)
}

export function show() {
  globalFeedLayer.addTo(mymap)
}

export function setup() {
  globalFeedLayer = L.layerGroup()

  addOverlay("GRS", globalFeedLayer, globalOverlay)

	adminFeed.register('device', handleAdminFeed)

	for (const device of Object.values(skylineApi.getDevices()) ) {
		if (device.type === 'GRS' && device.latitude) {
			addMarker(device)
		}
	}

  show()
}

function handleAdminFeed(entry) {
	if (!entry.device) {
		console.error("Got an admin feed without a device", entry)
		return
	}

	switch (entry.action) {
		case "CREATE":
			if (entry.device.type === 'GRS' && entry.device.latitude) {
				addMarker(entry.device)
			}
			break
		case "UPDATE":
			if (entry.device.type === 'GRS' && entry.device.latitude) {
				if (markers[entry.device.id]) {
					updateMarker(entry.device)
				} else {
					addMarker(entry.device)
				}
			}
			break
		case "DELETE":
			removeMarker(entry.device)
			break
		default:
			console.error("Got an unexpected action in admin feed", entry)
	}
}

function addMarker(device) {
  const marker = L.marker([0,0])
	markers[device.id] = marker
	updateMarker(device)
	marker.addTo(globalFeedLayer)
	return marker
}


function updateMarker(device)  {
	const marker = markers[device.id]
	console.assert(marker, 'Given invalid device to update marker', device)
  marker.setLatLng([device.latitude, device.longitude])
  marker.bindPopup(`GRS: ${device.name}`)
	marker.setIcon(L.icon({
    iconUrl: device.state === "DISCONNECTED" ? groundInactiveIcon : groundRegisteredIcon,
    iconSize: [25, 25],
    iconAnchor: [12.5, 12.5]
  }))
}

function removeMarker(device) {
	const marker = markers[device.id]
	if (!marker) return
	marker.removeFrom(globalFeedLayer)
	delete markers[device.id]
}
